import {type NotificationUpdatesQuery} from '../__generated__/queries.api-types';
import type * as Types from './types';

export const transformGraphQL = (query: NotificationUpdatesQuery): Types.UpdatesFromREST => ({
    warnings: [], // Not yet implemented
    notifications: {
        total: 0, // Not yet implemented
        unseen: query.me.notifications.unseen,
        userContexts: query.me.notifications.userContextCounts.reduce((map, context) => {
            return {
                ...map,
                [context.userContext.id]: context.unseen,
            };
        }, {} as NonNullable<Types.UpdatesFromREST['notifications']['userContexts']>),
    },
    conversations: {
        ALL: {
            total: query.me.conversations.inbox.total.all,
            unread: query.me.conversations.inbox.unseen.all,
        },
        OWN: {
            total: query.me.conversations.inbox.total.own,
            unread: query.me.conversations.inbox.unseen.own,
        },
        STAR: {
            total: query.me.conversations.inbox.total.star,
            unread: query.me.conversations.inbox.unseen.star,
        },
        userContexts: query.me.conversations.userContextCounts.reduce((map, context) => {
            return {
                ...map,
                [context.userContext.id]: {
                    own: context.inbox.unseen.own,
                    star: context.inbox.unseen.star,
                },
            };
        }, {} as NonNullable<Types.UpdatesFromREST['conversations']['userContexts']>),
    },
});
